export default "__VITE_ASSET__CEKKn4IU__"